export const handleCurrentQty = (
  dispatchMetrics,
  setCurrentQty,
  currentQty,
  setSelectQuantityWasUsed,
  hasInteracted,
  setHasInteracted
) => quantity => () => {
  const formattedQty = quantity >= 1 || quantity === '' ? quantity : 1;
  const label = quantity > currentQty ? 'adicionar' : 'remover';
  setSelectQuantityWasUsed(true);
  setCurrentQty(formattedQty);

  if (!hasInteracted) {
    dispatchMetrics('event:track', {
      category: 'pdp',
      action: 'seletor-quantidade',
      label,
    });

    setHasInteracted(true);
  }
};

export const handleKeyPress = e => {
  if (!/[0-9]/.test(e.key) || e.target.value.length >= 3) {
    e.preventDefault();
  }
};

export const dispatchTimer = (setCurrentQty, setError, newQty) => () => {
  setCurrentQty(setNewQty(newQty));
  setError(null);
};

export const clearTimer = timer => () => clearTimeout(timer);

export const setNewQty = newQty => newQty;

export const toggleEditing = (editing, setEditing, inputRef) => () => {
  !editing && inputRef?.current?.focus();
  setEditing(!editing);
};
